import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import styles from './BodyText.css'

const BodyText = ({ text, i18nKey, intl }) => {
  let paragraphs = i18nKey
    ? [intl.formatMessage({ id: i18nKey })]
    : Array.isArray(text) ? text : [text]
  return (
    <div className={styles.body_text}>
      {paragraphs.map((p, idx) =>
        <p key={`_${idx}`}>
          {p}
        </p>
      )}
    </div>
  )
}

BodyText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  i18nKey: PropTypes.string
}

export default injectIntl(BodyText)
